import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=36b2a322&scoped=true&"
var script = {}
import style0 from "./rules.vue?vue&type=style&index=0&id=36b2a322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2a322",
  null
  
)

export default component.exports